import styled from "styled-components";

export const LabelStyled = styled.label`
  font-size: 15px;
  color: black;
  margin-bottom: 5px !important;
  display: block;
`;
